import { FC } from "react";
import JourneyCommentsFlyIn from "../JourneyCommentsFlyIn/JourneyCommentsFlyIn";

interface GridCommentFlyInProps {
    openCommentFlyIn: boolean;
    closeFlyIn: VoidFunction;
    commentJourneyId: number;
}

export const GridCommentFlyIn: FC<GridCommentFlyInProps> = ({ commentJourneyId, openCommentFlyIn, closeFlyIn }) => {
    return <JourneyCommentsFlyIn closeDrawer={closeFlyIn} journeyId={commentJourneyId} open={openCommentFlyIn} />;
};
